import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/i18n';
import { UiContainer } from '../../../state/ui';
import { getColorForCategory, stripFacetCategory } from '../../utils';
import { toQuery } from '../../Routes';

export type AutocompleteItem = {
	term: string;
	facetCategory: string;
};

export const SearchSuggestion = ({ item }: { item: AutocompleteItem }): JSX.Element => {
	const { term, facetCategory } = item;
	const t = useTranslation().search;
	const urls = useTranslation().routes;
	const { setIsSearchFormFocused } = UiContainer.useContainer();

	function suggestionIsFocused(event: React.FocusEvent<HTMLAnchorElement, Element>): boolean {
		return event.relatedTarget?.className === 'search-suggestion';
	}

	return (
		<Link
			to={`${urls.search}?${toQuery({ q: term, facetCategory })}`}
			className="search-suggestion"
			onBlur={(e) => setIsSearchFormFocused(suggestionIsFocused(e))}
		>
			<strong>{term}</strong>
			{facetCategory ? (
				<>
					{' '}
					{t.within}{' '}
					<span style={{ backgroundColor: `var(${getColorForCategory(facetCategory)})` }}>
						{stripFacetCategory(facetCategory)}
					</span>
				</>
			) : (
				<></>
			)}
		</Link>
	);
};
